<template>
    <div class="section section-white">
        <div class="section-header with-border">
          <div class="section-title">积分配置</div>
        </div>
        <el-form ref="form" :model="form" label-position="left" label-width="180px">
            <div class="section-body">
                <el-form-item label="是否开启积分：">
                    <el-switch v-model="form.isOpenMemberPoint" :width="60" active-value="true" inactive-value="false"
                               inactive-color="#ccc" active-text="开启" inactive-text="关闭"
                               active-color="#13ce66"></el-switch>
                </el-form-item>
              <template v-if="form.isOpenMemberPoint == 'true'">
                  <el-form-item label="积分获取比例：">
                      订单金额1元人民币 获得<el-input  type="number"  v-model="form.gain_point" placeholder="" style="width: 120px;" :min="1" :max="9999999"/>积分
                  </el-form-item>
                   <el-form-item label="积分获取限制：">
                      每月最多获取<el-input  type="number"  v-model="form.gain_limit" placeholder="" style="width: 120px;" :min="1" :max="9999999"/>积分
                      <div class="frm-tips">不限制请填写999999</div>
                  </el-form-item>

                   <el-form-item label="积分获取时间：">
                     订单完成<el-input  type="number"  v-model="form.gain_time" placeholder="" style="width: 120px;" :min="1" :max="9999999"/>天，获取积分
                  </el-form-item>

                  <el-form-item label="是否开启积分抵扣：">
                  <el-switch v-model="form.isOpenDeductPoint" :width="60" active-value="true" inactive-value="false"
                               inactive-color="#ccc" active-text="开启" inactive-text="关闭"
                               active-color="#13ce66"></el-switch>
                </el-form-item>
                 <el-form-item label="积分抵扣比例：">
                      <el-input  type="number"  v-model="form.deduct_point" placeholder="" style="width: 120px;" :min="1" :max="9999999"/>积分 抵扣1元人民币
                  </el-form-item>
                  <el-form-item label="积分抵扣使用限制：">
                     每月最多抵扣使用<el-input type="number"  v-model="form.deduct_limit" value="0" style="width: 150px;" :min="0" :max="9999999"/>积分
                     <div class="frm-tips">不限制请填写999999</div>
                  </el-form-item>
              </template>
            </div>
            <div class="section-footer with-border content-center">
                <el-button type="primary" @click="save">保 存</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
  import {savePointRule, getPointRule} from '../../../api/promotions'

  export default {
    data() {
      return {
        form: {
          isOpenMemberPoint: 'false',
          gain_point: 0,
          gain_limit: 0,
          gain_time: 3,
          isOpenDeductPoint:false,
          deduct_point:0,
          deduct_limit:0
        },
      }
    },
    methods: {
      getPointRule() {
        getPointRule().then(response => {
          this.form = response.data.data;
        })
      },
      save() {
        if(this.form.isOpenMemberPoint){
          if(this.form.gain_point<=0 || this.form.gain_time<=0){
            this.$message({message: '请配置获取积分参数', type: 'error'})
            return
          }
          if(this.form.gain_limit == '' || this.form.gain_limit == 0){
            this.form.gain_limit = 9999999
          }
          if(this.form.gain_limit < this.form.gain_point){
            this.$message({message: '获取积分限制不能小于获取积分比例', type: 'error'})
            return
          }

           if(this.form.isOpenDeductPoint){
            if(this.form.deduct_point == ''){
              this.$message({message: '请配置积分抵扣参数', type: 'error'})
              return
            }
            if(this.form.deduct_limit == '' || this.form.deduct_limit == 0){
              this.form.deduct_limit = 9999999
            }
             if(this.form.deduct_limit < this.form.deduct_point){
            this.$message({message: '抵扣积分限制不能小于抵扣积分比例', type: 'error'})
            return
          }
          }
        }
        savePointRule(this.form).then(response => {
          this.getPointRule()
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        })
      }
    },
    mounted() {
       this.getPointRule()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// index.vue?74b2a086